import React from 'react';
import { NavLink } from 'react-router-dom';
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from '../../Components/Accordion/Accordion';
import { DoubleArrowRightIcon, HomeIcon, SearchIcon, SettingsIcon, UserIcon } from '../../Components/Icons/Icons';
import Header from '../Header/Header';
import { useSelector, useDispatch } from "react-redux";
import { setToggleSideBar } from '../../store/UserSlices/ToggleSideBar';
import { Button } from '../../Components/Button/Button';
import { ClipboardCopyIcon, DoubleArrowLeftIcon } from '@radix-ui/react-icons';
import { ClipboardCopy, Users2Icon, VideoIcon } from 'lucide-react';
import { DocumentIcon, VideoCameraSlashIcon } from '@heroicons/react/16/solid';
// import { setToggleSideBar } from '../../store/UserSlices/ToggleSideBar';
// import { setDarkMode } from '../../store/UserSlices/DarkMode';

import { FaBars } from "react-icons/fa";

const Sidebar = () => {
    const dispatch = useDispatch();
    const { toggleSideBar } = useSelector((state) => state.toggleSideBar);
    const { darkMode } = useSelector((state) => state.darkMode)

    const handleToggle = () => {
        dispatch(setToggleSideBar());
    }

    // const handleDarkMode = () => {
    //     dispatch(setDarkMode());
    // }
    return (
        <div
            className={`fixed  inset-y-0 left-0 z-50 w-64 shadow-lg transition-transform duration-300 bg-white text-black dark:bg-gray-900 dark:text-white ${toggleSideBar ? "translate-x-0" : "-translate-x-full"
                } ${darkMode ? "dark" : " "}`}
        >
            {/*<Header />*/}
            <div className="flex h-14 items-center justify-between border-b px-1">
                <h3 className="text-lg font-medium">Recc Admin Panel</h3>
                <div className="flex items-center gap-2">
                    {
                        toggleSideBar ?
                            <Button variant="ghost" size="icon" className="rounded-full" onClick={handleToggle}>
                                <div className="menu-icon">
                                    <FaBars size={15} />
                                </div>
                                <span className="sr-only">Close</span>
                            </Button> :
                            <Button variant="ghost" size="icon" className="rounded-full" onClick={handleToggle}>
                                <div className="menu-icon">
                                    <FaBars size={15} />
                                </div>                                
                                <span className="sr-only">Close</span>
                            </Button>
                    }
                    {/* <button variant="ghost" size="icon" className="rounded-full" onClick={handleDarkMode}>
                    {darkMode ? <SunIcon className="h-5 w-5" /> : <MoonIcon className="h-5 w-5" />}
                    <span className="sr-only">Toggle dark mode</span>
                </button>*/}
                    <div className="flex items-center gap-4">


                    </div>
                </div>
            </div>


            <nav className="flex flex-col">
                <NavLink to="/" className={({ isActive }) =>
                    `flex items-center gap-3 px-4 py-3 text-sm font-medium transition-colors hover:bg-gray-200 dark:hover:bg-gray-700 ${isActive ? 'bg-gray-200 dark:bg-gray-700' : ''}`
                }
                >
                    <HomeIcon className="h-5 w-5" />
                    Home
                </NavLink>
                <NavLink to="users" className={({ isActive }) =>
                    `flex items-center gap-3 px-4 py-3 text-sm font-medium transition-colors hover:bg-gray-200 dark:hover:bg-gray-700 ${isActive ? 'bg-gray-200 dark:bg-gray-700' : ''}`
                }
                >
                    <Users2Icon className="h-5 w-5" />
                    Users
                </NavLink>

                <NavLink to="videos" className={({ isActive }) =>
                    `flex items-center gap-3 px-4 py-3 text-sm font-medium transition-colors hover:bg-gray-200 dark:hover:bg-gray-700 ${isActive ? 'bg-gray-200 dark:bg-gray-700' : ''}`
                }
                >
                    <VideoIcon className="h-5 w-5" />
                    Videos
                </NavLink>
                <NavLink to="reports" className={({ isActive }) =>
                    `flex items-center gap-3 px-4 py-3 text-sm font-medium transition-colors hover:bg-gray-200 dark:hover:bg-gray-700 ${isActive ? 'bg-gray-200 dark:bg-gray-700' : ''}`
                }
                >
                    <ClipboardCopyIcon className="h-5 w-5" />
                    Reports
                </NavLink>
                <NavLink to="user-reports" className={({ isActive }) =>
                    `flex items-center gap-3 px-4 py-3 text-sm font-medium transition-colors hover:bg-gray-200 dark:hover:bg-gray-700 ${isActive ? 'bg-gray-200 dark:bg-gray-700' : ''}`
                }
                >
                    <ClipboardCopyIcon className="h-5 w-5" />
                    User Reports
                </NavLink>

            </nav>
        </div>
    )
};

export default Sidebar;

